import { BorrowerOnboardingDetails, DocumentType } from '@nemuru-eng/js-api-client';

import { isNieEuDocumentType } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/utils/nieDocumentTypes.utils';
import {
  selectCardIdArray,
  selectNationalityPeriodArray,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/config/nieData.config';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export interface NieDataFormProps extends FormGridOptions {
  documentType?: DocumentType | null;
  nieData?: BorrowerOnboardingDetails['nieData'];
}

export const NieDataForm = ({ documentType, nieData, fullWidth, fieldVariant, direction }: NieDataFormProps) => {
  const isNieEu = isNieEuDocumentType(documentType);

  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
      <SelectFormField
        name={'nationalityPeriod'}
        label={'NATIONALITY_PERIOD'}
        value={`NATIONALITY_PERIOD_${nieData?.nationalityPeriod}`}
        selectOptions={selectNationalityPeriodArray}
        fieldVariant={fieldVariant}
      />
      {!isNieEu && (
        <SelectFormField
          name={'cardId'}
          label={'RESIDENCE_CARD_TYPE'}
          value={fieldVariant === FieldVariant.form ? nieData?.cardId : `CARD_ID_${nieData?.cardId}`}
          selectOptions={selectCardIdArray}
          fieldVariant={fieldVariant}
        />
      )}
      {!isNieEu && (
        <DateFormField
          name={'expirationDateCard'}
          label={'RESIDENCE_CARD_EXPIRATION_DATE'}
          value={nieData?.expirationDateCard}
          fieldVariant={fieldVariant}
          disablePast
        />
      )}
      <DateFormField
        name={'socialSecurityDate'}
        label={'SOCIAL_SECURITY_REGISTRATION_DATE'}
        value={nieData?.socialSecurityDate}
        fieldVariant={fieldVariant}
        disableFuture
      />
      <NumberFormField
        name={'numberOfWork'}
        label={'NUMBER_OF_WORK'}
        type="number"
        value={nieData?.numberOfWork}
        allowDecimals={false}
        fieldVariant={fieldVariant}
      />
    </FormGridContainer>
  );
};
